/*
 * Cap Messages
 *
 * This contains all the text for the Cap container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'badges.components.pages.Cap';

export default defineMessages({
  tab1: {
    id: `${scope}.tab1`,
    defaultMessage: 'Tab 1',
  },
  tab2: {
    id: `${scope}.tab2`,
    defaultMessage: 'Tab 2',
  },
  tab3: {
    id: `${scope}.tab3`,
    defaultMessage: 'Tab 3',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the Cap container!',
  },
  programs: {
    id: `${scope}.programs`,
    defaultMessage: 'Programs',
  },
  promotions: {
    id: `${scope}.promotions`,
    defaultMessage: 'Promotions',
  },
  creatives: {
    id: `${scope}.creatives`,
    defaultMessage: 'Creatives',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Something went wrong!',
  },
  message: {
    id: `${scope}.message`,
    defaultMessage: 'Message',
  },
  reports: {
    id: `${scope}.reports`,
    defaultMessage: 'Reports',
  },
  alerts: {
    id: `${scope}.alerts`,
    defaultMessage: 'Alerts',
  },
  alert: {
    id: `${scope}.alert`,
    defaultMessage: 'Alert',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  rank: {
    id: `${scope}.rank`,
    defaultMessage: 'Rank',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  select: {
    id: `${scope}.select`,
    defaultMessage: 'Select',
  },
  selectDate: {
    id: `${scope}.selectDate`,
    defaultMessage: 'Select Date',
  },
  selectPeriod: {
    id: `${scope}.selectPeriod`,
    defaultMessage: 'select period',
  },
  noResultsFound: {
    id: `${scope}.noResultsFound`,
    defaultMessage: 'No results found',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  noMessages: {
    id: `${scope}.noMessages`,
    defaultMessage: 'No Messages',
  },
  create: {
    id: `${scope}.create`,
    defaultMessage: 'Create',
  },
  edit: {
    id: `${scope}.edit`,
    defaultMessage: 'Edit',
  },
  duplicate: {
    id: `${scope}.duplicate`,
    defaultMessage: 'Duplicate',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  configure: {
    id: `${scope}.configure`,
    defaultMessage: 'Configure',
  },
  program: {
    id: `${scope}.program`,
    defaultMessage: 'Program',
  },
  configureProgram: {
    id: `${scope}.configureProgram`,
    defaultMessage: 'Configure Program',
  },
  reconfigureProgram: {
    id: `${scope}.reconfigureProgram`,
    defaultMessage: 'Reconfigure Program',
  },
  workflowsUsingCondition: {
    id: `${scope}.workflowsUsingCondition`,
    defaultMessage: 'Workflows using the condition',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  tiers: {
    id: `${scope}.tiers`,
    defaultMessage: 'Tiers',
  },
  areYouSureText: {
    id: `${scope}.areYouSureText`,
    defaultMessage: 'Are you sure?',
  },
  changeOk: {
    id: `${scope}.changeOk`,
    defaultMessage: 'Ok, change',
  },
  done: {
    id: `${scope}.done`,
    defaultMessage: 'Done',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'Next',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: 'Confirm',
  },
  upgradeBasedOn: {
    id: `${scope}.upgradeBasedOn`,
    defaultMessage: 'Upgrade based on',
  },
  pointsCondition: {
    id: `${scope}.pointsCondition`,
    defaultMessage: 'When point',
  },
  upgradeType: {
    id: `${scope}.upgradeType`,
    defaultMessage: 'Upgrade type',
  },
  createNewTier: {
    id: `${scope}.createNewTier`,
    defaultMessage: 'Create New Tier',
  },
  tierColor: {
    id: `${scope}.tierColor`,
    defaultMessage: 'Tier Color',
  },
  and: {
    id: `${scope}.and`,
    defaultMessage: 'And',
  },
  always: {
    id: `${scope}.always`,
    defaultMessage: 'Always',
  },
  months: {
    id: `${scope}.months`,
    defaultMessage: 'Months',
  },
  badges: {
    id: `${scope}.badges`,
    defaultMessage: 'Badges',
  },
  badgesWithCount: {
    id: `${scope}.badgesWithCount`,
    defaultMessage: 'badge{badgeCount, plural, one{} other{s}}',
  },
  campaigns: {
    id: `${scope}.campaigns`,
    defaultMessage: 'Campaigns',
  },
  expiryCondition: {
    id: `${scope}.expiryCondition`,
    defaultMessage: 'Expiry Condition',
  },
  earnConditions: {
    id: `${scope}.earnConditions`,
    defaultMessage: 'Earn Conditions',
  },
  earnConditionsDesc: {
    id: `${scope}.earnConditionsDesc`,
    defaultMessage: 'Define how customers will earn points',
  },
  addEarnConditions: {
    id: `${scope}.addEarnConditions`,
    defaultMessage: 'Add Earn Conditions',
  },
  redeemConditions: {
    id: `${scope}.redeemConditions`,
    defaultMessage: 'Redeem Conditions',
  },
  redeemConditionsDesc: {
    id: `${scope}.redeemConditionsDesc`,
    defaultMessage: 'Define how customers can redeem points',
  },
  addRedeemConditions: {
    id: `${scope}.addRedeemConditions`,
    defaultMessage: 'Add Redeem Conditions',
  },
  expiryConditions: {
    id: `${scope}.expiryConditions`,
    defaultMessage: 'Expiry Conditions',
  },
  expiryConditionsDesc: {
    id: `${scope}.expiryConditionsDesc`,
    defaultMessage: 'Define how points get expired for every tier',
  },
  addExpiryConditions: {
    id: `${scope}.addExpiryConditions`,
    defaultMessage: 'Add Expiry Conditions',
  },
  returnConditions: {
    id: `${scope}.returnConditions`,
    defaultMessage: 'Return Conditions',
  },
  returnConditionsDesc: {
    id: `${scope}.returnConditionsDesc`,
    defaultMessage: 'Define crieteria for accepting points ',
  },
  addReturnConditions: {
    id: `${scope}.addReturnConditions`,
    defaultMessage: 'Add Return Conditions',
  },
  createFirstTier: {
    id: `${scope}.createFirstTier`,
    defaultMessage: 'Create First Tier',
  },
  saveAndContinue: {
    id: `${scope}.saveAndContinue`,
    defaultMessage: 'Save & Continue',
  },
  previewAndSave: {
    id: `${scope}.previewAndSave`,
    defaultMessage: 'Preview & Save',
  },
  orgNotEIEnabled: {
    id: `${scope}.orgNotEIEnabled`,
    defaultMessage: 'Org is not EI enabled',
  },
  tier: {
    id: `${scope}.tier`,
    defaultMessage: 'Tier',
  },
  timePeriod: {
    id: `${scope}.timePeriod`,
    defaultMessage: 'Time Period',
  },
  pointExpiryPeriod: {
    id: `${scope}.pointExpiryPeriod`,
    defaultMessage: 'Points expiry period',
  },
  conditionName: {
    id: `${scope}.conditionName`,
    defaultMessage: 'Condition Name',
  },
  workflow: {
    id: `${scope}.workflow`,
    defaultMessage: 'Workflow',
  },
  days: {
    id: `${scope}.days`,
    defaultMessage: 'Days',
  },
  daysWithCount: {
    id: `${scope}.daysWithCount`,
    defaultMessage: 'day{daysCount, plural, one{} other{s}}',
  },
  weeks: {
    id: `${scope}.weeks`,
    defaultMessage: 'Weeks',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
  never: {
    id: `${scope}.never`,
    defaultMessage: 'Never',
  },
  allTiers: {
    id: `${scope}.allTiers`,
    defaultMessage: 'All tiers',
  },
  atEnd: {
    id: `${scope}.atEnd`,
    defaultMessage: 'At the end of',
  },
  on: {
    id: `${scope}.on`,
    defaultMessage: 'On',
  },
  createdSuccessfully: {
    id: `${scope}.createdSuccessfully`,
    defaultMessage: 'Created Successfully',
  },
  editedSuccessfully: {
    id: `${scope}.editedSuccessfully`,
    defaultMessage: 'Edited Successfully',
  },
  savedSuccessfully: {
    id: `${scope}.savedSuccessfully`,
    defaultMessage: 'Saved Successfully',
  },
  editDetails: {
    id: `${scope}.editDetails`,
    defaultMessage: 'Edit Details',
  },
  allocationType: {
    id: `${scope}.allocationType`,
    defaultMessage: 'Allocation Type',
  },
  allocateBasedOn: {
    id: `${scope}.allocatedBasedOn`,
    defaultMessage: 'Allocate Based On',
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: 'details',
  },
  module: {
    id: `${scope}.module`,
    defaultMessage: 'module',
  },
  noCommunications: {
    id: `${scope}.noCommunications`,
    defaultMessage: 'No communications available',
  },
  sms: {
    id: `${scope}.sms`,
    defaultMessage: 'SMS',
  },
  weChat: {
    id: `${scope}.weChat`,
    defaultMessage: 'WeChat',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  pushNotification: {
    id: `${scope}.pushNotification`,
    defaultMessage: 'Push notification',
  },
  tierUpgrade: {
    id: `${scope}.tierUpgrade`,
    defaultMessage: 'Tier Upgrade',
  },
  tierDowngrade: {
    id: `${scope}.tierDwongrade`,
    defaultMessage: 'Tier Downgrade',
  },
  somethingWentWrongTitle: {
    id: `${scope}.somethingWentWrongTitle`,
    defaultMessage: 'Sorry, something went wrong.',
  },
  somethingWentWrongDesc: {
    id: `${scope}.somethingWentWrongDesc`,
    defaultMessage:
      'Please try again. If this issue occurs again, please reach out to Capillary support team.',
  },
  tryRefreshing: {
    id: `${scope}.tryRefreshing`,
    defaultMessage: 'Try refreshing again',
  },
  modeTierChangeWindow: {
    id: `${scope}.modeTierChangeWindow`,
    defaultMessage: 'Tier Change Window',
  },
  modeCalendarBasedCyclicWindow: {
    id: `${scope}.modeCalendarBasedCyclicWindow`,
    defaultMessage: 'Calendar Based Cyclic Window',
  },
  modeCyclicWindow: {
    id: `${scope}.modeCyclicWindow`,
    defaultMessage: 'Cyclic Window',
  },
  modeMovingWindow: {
    id: `${scope}.modeMovingWindow`,
    defaultMessage: 'Moving Window',
  },
  sum: {
    id: `${scope}.sum`,
    defaultMessage: 'Sum',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Count',
  },
  operationEqualTo: {
    id: `${scope}.operationEqualTo`,
    defaultMessage: 'Equal to',
  },
  operationGreaterThan: {
    id: `${scope}.operationGreaterThan`,
    defaultMessage: 'Greater than',
  },
  operationLessThan: {
    id: `${scope}.operationLessThan`,
    defaultMessage: 'Less than',
  },
  operationGreaterThanEqualTo: {
    id: `${scope}.operationGreaterThanEqualTo`,
    defaultMessage: 'Greater than or Equal to',
  },
  operationLessThanEqualTo: {
    id: `${scope}.operationLessThanEqualTo`,
    defaultMessage: 'Less than or Equal to',
  },
  operationModOf: {
    id: `${scope}.operationModOf`,
    defaultMessage: 'Mod of',
  },
  operationBetween: {
    id: `${scope}.operationBetween`,
    defaultMessage: 'Between',
  },
  is: {
    id: `${scope}.is`,
    defaultMessage: 'is',
  },
  billAmount: {
    id: `${scope}.billAmount`,
    defaultMessage: 'Bill Amount',
  },
  billDiscount: {
    id: `${scope}.billDiscount`,
    defaultMessage: 'Bill Discount',
  },
  billGrossAmount: {
    id: `${scope}.billGrossAmount`,
    defaultMessage: 'Bill Gross Amount',
  },
  billTotalQuantity: {
    id: `${scope}.billTotalQuantity`,
    defaultMessage: 'Bill Total Quantity',
  },
  lineitemAmount: {
    id: `${scope}.lineitemAmount`,
    defaultMessage: 'Lineitem Amount',
  },
  lineitemCount: {
    id: `${scope}.lineitemCount`,
    defaultMessage: 'Lineitem Count',
  },
  lineitemQuantity: {
    id: `${scope}.lineitemQuantity`,
    defaultMessage: 'Lineitem Quantity',
  },
  customerVisits: {
    id: `${scope}.customerVisits`,
    defaultMessage: 'Customer Visits',
  },
  points: {
    id: `${scope}.points`,
    defaultMessage: 'Points',
  },
  billExtendedField: {
    id: `${scope}.billExtendedField`,
    defaultMessage: 'Bill Extended Field',
  },
  lineitemExtendedField: {
    id: `${scope}.lineitemExtendedField`,
    defaultMessage: 'Lineitem Extended Field',
  },
  pointsTenderMode: {
    id: `${scope}.pointsTenderMode`,
    defaultMessage: 'Points tender mode',
  },
  redemptionReference: {
    id: `${scope}.redemptionReference`,
    defaultMessage: 'Redemption Reference in the Bill',
  },
  redemptionReferenceBillNo: {
    id: `${scope}.redemptionReferenceBillNo`,
    defaultMessage: 'Bill Number in Redemption API',
  },
  pointsReturnBasedOn: {
    id: `${scope}.pointsReturnBasedOn`,
    defaultMessage: 'Return used points based on',
  },
  eventDate: {
    id: `${scope}.eventDate`,
    defaultMessage: 'Event Date',
  },
  rollingFromEventDate: {
    id: `${scope}.rollingFromEventDate`,
    defaultMessage: 'Rolling Expiry from Event Date',
  },
  membershipExpiryDate: {
    id: `${scope}.membershipExpiryDate`,
    defaultMessage: 'Membership Event Date',
  },
  expiryDateBeforeRedemptionReversal: {
    id: `${scope}.expiryDateBeforeRedemptionReversal`,
    defaultMessage: 'Expiry Date before Redemption Reversal',
  },
  farthestPointsTransferedExpiryDate: {
    id: `${scope}.farthestPointsTransferedExpiryDate`,
    defaultMessage: 'farthestPointsTransferedExpiryDate',
  },
  expiryDateBeforePointsContributionToGroup: {
    id: `${scope}.expiryDateBeforePointsContributionToGroup`,
    defaultMessage: 'expiryDateBeforePointsContributionToGroup',
  },
  digits: {
    id: `${scope}.digits`,
    defaultMessage: 'digits',
  },
  note: {
    id: `${scope}.note`,
    defaultMessage: 'Note',
  },
  or: {
    id: `${scope}.or`,
    defaultMessage: 'Or',
  },
  attribute: {
    id: `${scope}.attribute`,
    defaultMessage: 'Attribute',
  },
  value: {
    id: `${scope}.value`,
    defaultMessage: 'Value',
  },
  id: {
    id: `${scope}.id`,
    defaultMessage: 'ID',
  },
  duration: {
    id: `${scope}.duration`,
    defaultMessage: 'Duration',
  },
  images: {
    id: `${scope}.images`,
    defaultMessage: 'Images',
  },
  offOn: {
    id: `${scope}.offOn`,
    defaultMessage: 'off on',
  },
  owner: {
    id: `${scope}.owner`,
    defaultMessage: 'Owner',
  },
  scope: {
    id: `${scope}.scope`,
    defaultMessage: 'Scope',
  },
  loyalty: {
    id: `${scope}.loyalty`,
    defaultMessage: 'Loyalty',
  },
  loyaltyPromotion: {
    id: `${scope}.loyaltyPromotion`,
    defaultMessage: 'Loyalty Promotion',
  },
  milestone: {
    id: `${scope}.milestone`,
    defaultMessage: 'Milestone',
  },
  journey: {
    id: `${scope}.journey`,
    defaultMessage: 'Journey',
  },
  campaign: {
    id: `${scope}.campaign`,
    defaultMessage: 'Campaign',
  },
  createBadgeRewardsCatalog: {
    id: `${scope}.createBadgeRewardsCatalog`,
    defaultMessage: 'Rewards Catalog',
  },
  membercare: {
    id: `${scope}.membercare`,
    defaultMessage: 'Membercare',
  },
  historicalImport: {
    id: `${scope}.historicalImport`,
    defaultMessage: 'Historical Import',
  },
  inProgress: {
    id: `${scope}.inProgress`,
    defaultMessage: 'In progress',
  },
  issued: {
    id: `${scope}.issued`,
    defaultMessage: 'Issued',
  },
  unIssued: {
    id: `${scope}.unIssued`,
    defaultMessage: 'Unissued',
  },
  optional: {
    id: `${scope}.optional`,
    defaultMessage: 'Optional',
  },
  notDefined: {
    id: `${scope}.notDefined`,
    defaultMessage: 'Not defined',
  },
  configuration: {
    id: `${scope}.configuration`,
    defaultMessage: 'Configuration',
  },
  information: {
    id: `${scope}.information`,
    defaultMessage: 'Information',
  },
  createdOn: {
    id: `${scope}.createdOn`,
    defaultMessage: 'Created on',
  },
  createdByRole: {
    id: `${scope}.createdByRole`,
    defaultMessage: 'Created by (Role)',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'No',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  bulkUpload: {
    id: `${scope}.bulkUpload`,
    defaultMessage: 'Bulk upload',
  },
  ownedBy: {
    id: `${scope}.ownedBy`,
    defaultMessage: 'Owned by',
  },
  claimedBy: {
    id: `${scope}.claimedBy`,
    defaultMessage: 'Claimed by',
  },
  live: {
    id: `${scope}.live`,
    defaultMessage: 'Live',
  },
  upcoming: {
    id: `${scope}.upcoming`,
    defaultMessage: 'Upcoming',
  },
  ended: {
    id: `${scope}.ended`,
    defaultMessage: 'Ended',
  },
  disabled: {
    id: `${scope}.disabled`,
    defaultMessage: 'Disabled',
  },
  pause: {
    id: `${scope}.pause`,
    defaultMessage: 'Pause',
  },
  coupons: {
    id: `${scope}.coupons`,
    defaultMessage: "Coupon { couponsCount, plural, one{} other{ s }}",
  },
  loyaltyPromotions: {
    id: `${scope}.loyaltyPromotions`,
    defaultMessage: 'Loyalty Promotions',
  },
  engage: {
    id: `${scope}.engage`,
    defaultMessage: 'Engage',
  },
  clearAll: {
    id: `${scope}.clearAll`,
    defaultMessage: 'Clear all',
  },
  viewBadge: {
    id: `${scope}.viewBadge`,
    defaultMessage: 'View badge',
  },
  createBadge: {
    id: `${scope}.createBadge`,
    defaultMessage: 'Create badge',
  },
  editBadge: {
    id: `${scope}.editBadge`,
    defaultMessage: 'Edit badge',
  },
  previewBadge: {
    id: `${scope}.previewBadge`,
    defaultMessage: 'Preview badge',
  },
  newBadge: {
    id: `${scope}.newBadge`,
    defaultMessage: 'New badge',
  },
  badgeName: {
    id: `${scope}.badgeName`,
    defaultMessage: 'Badge name',
  },
  basicDetails: {
    id: `${scope}.basicDetails`,
    defaultMessage: 'Basic details',
  },
  earn: {
    id: `${scope}.earn`,
    defaultMessage: 'Earn',
  },
  benefits: {
    id: `${scope}.benefits`,
    defaultMessage: 'Benefits',
  },
  customFields: {
    id: `${scope}.customFields`,
    defaultMessage: 'Custom fields',
  },
  badgeGroups: {
    id: `${scope}.badgeGroups`,
    defaultMessage: 'Groups',
  },
  activity: {
    id: `${scope}.activity`,
    defaultMessage: 'Activity',
  },
  viewMore: {
    id: `${scope}.viewMore`,
    defaultMessage: 'View more',
  },
  viewLess: {
    id: `${scope}.viewLess`,
    defaultMessage: 'View less',
  },
  termsAndConditions: {
    id: `${scope}.termsAndConditions`,
    defaultMessage: 'Terms and conditions',
  },
  set: {
    id: `${scope}.set`,
    defaultMessage: 'Set',
  },
  notClaimed: {
    id: `${scope}.notClaimed`,
    defaultMessage: 'Not claimed',
  },
  trigger: {
    id: `${scope}.trigger`,
    defaultMessage: 'Trigger',
  },
  displayDays: {
    id: `${scope}.displayDays`,
    defaultMessage: '{daysCount} day{daysCount, plural, one{} other{s}}',
  },
  displayWeeks: {
    id: `${scope}.displayWeeks`,
    defaultMessage: '{weeksCount} week{weeksCount, plural, one{} other{s}}',
  },
  displayMonths: {
    id: `${scope}.displayMonths`,
    defaultMessage: '{monthsCount} month{monthsCount, plural, one{} other{s}}',
  },
  displayYears: {
    id: `${scope}.displayYears`,
    defaultMessage: '{yearsCount} year{yearsCount, plural, one{} other{s}}',
  },
  referralCampaign: {
    id: `${scope}.referralCampaign`,
    defaultMessage: 'Referral Campaign',
  },
  audienceCampaigns: {
    id: `${scope}.audienceCampaigns`,
    defaultMessage: 'Audience Campaigns',
  },
  broadcastCampaign: {
    id: `${scope}.broadcastCampaign`,
    defaultMessage: 'Broadcast Campaign',
  },
  rewardsCatalog: {
    id: `${scope}.rewardsCatalog`,
    defaultMessage: 'Rewards Catalog',
  },
  goodwillModule: {
    id: `${scope}.goodwillModule`,
    defaultMessage: 'Goodwill Module',
  },
  inactive: {
    id: `${scope}.inactive`,
    defaultMessage: 'Inactive',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  syncsEvery2Hr: {
    id: `${scope}.syncsEvery2Hr`,
    defaultMessage: 'Syncs every 2 hrs',
  },
  issueExpiry: {
    id: `${scope}.issueExpiry`,
    defaultMessage: 'Issue expiry',
  },
  enrolExpiry: {
    id: `${scope}.enrolExpiry`,
    defaultMessage: 'Enrolment expiry',
  },
  issueExpiryTooltip: {
    id: `${scope}.issueExpiryTooltip`,
    defaultMessage:
      'This is the duration until which the badge will remain with the customer once issued to them',
  },
  editIssueExpiryTooltip_1: {
    id: `${scope}.editIssueExpiryTooltip_1`,
    defaultMessage:
      'If no issual limit is defined, unlimited badges can be issued to the customers ',
  },
  editIssueExpiryTooltip_2: {
    id: `${scope}.editIssueExpiryTooltip_2`,
    defaultMessage:
      '2. Once edited, the updated issue limit will be applicable for the new customers in the future',
  },
  editBenefitsTooltip: {
    id: `${scope}.editBenefitsTooltip`,
    defaultMessage:
      'Once edited, the updated benefits will be applicable for the new customers in the future',
  },
  enrolExpiryTooltip: {
    id: `${scope}.enrolExpiryTooltip`,
    defaultMessage:
      'This is the duration from the customer’s enrolment date until a specified time to fulfil the issuance criteria',
  },
  issueLimit: {
    id: `${scope}.issueLimit`,
    defaultMessage: 'Issue limit',
  },
  badgesIssued: {
    id: `${scope}.badgesIssued`,
    defaultMessage: 'Badges issued',
  },
  issue: {
    id: `${scope}.issue`,
    defaultMessage: 'Issue',
  },
  enrol: {
    id: `${scope}.enrol`,
    defaultMessage: 'Enrol',
  },
  ownerTooltip: {
    id: `${scope}.ownerTooltip`,
    defaultMessage: 'The module(s) for which the badge has been created',
  },
  ownerTooltipforCreateMode: {
    id: `${scope}.ownerTooltipforCreateMode`,
    defaultMessage: 'The module(s) for which the badge is being created',
  },
  uploadImage: {
    id: `${scope}.uploadImage`,
    defaultMessage: 'Upload image',
  },
  uploadInstructionTitle: {
    id: `${scope}.uploadInstructionTitle`,
    defaultMessage: 'Upload instructions',
  },
  uploadInstruction1: {
    id: `${scope}.uploadInstruction1`,
    defaultMessage:
      'Maximum upto <b>3 images</b> can be uploaded, one for each tag',
  },
  uploadInstruction2: {
    id: `${scope}.uploadInstruction2`,
    defaultMessage: 'Each image can have max. size upto <b>{size} MB</b>',
  },
  uploadInstruction3: {
    id: `${scope}.uploadInstruction3`,
    defaultMessage: 'Aspect ratio should be 1:1 for each image',
  },
  uploadInstruction4: {
    id: `${scope}.uploadInstruction4`,
    defaultMessage: 'Upload images in JPEG, JPG, PNG or SVG format',
  },
  uploadImageInductiveText: {
    id: `${scope}.uploadImageInductiveText`,
    defaultMessage:
      'Upload images that represent your badge. A good image stands out and draws viewers attention',
  },
  countWithCoupons: {
    id: `${scope}.countWithCoupons`,
    defaultMessage: 'Coupon{count, plural, one{} other{s}}',
  },
  countWithLoyaltyPromotions: {
    id: `${scope}.countWithLoyaltyPromotions`,
    defaultMessage: 'Loyalty Promotion{count, plural, one{} other{s}}',
  },
  countWithPoints: {
    id: `${scope}.countWithPoints`,
    defaultMessage: 'Point{count, plural, one{} other{s}}',
  },
  countWithCartPromotions: {
    id: `${scope}.countWithCartPromotions`,
    defaultMessage: 'Cart promotion{count, plural, one{} other{s}}',
  },
  countWithGiftVouchers: {
    id: `${scope}.countWithGiftVouchers`,
    defaultMessage: 'Gift voucher{count, plural, one{} other{s}}',
  },
  exit: {
    id: `${scope}.exit`,
    defaultMessage: 'Exit',
  },
  badgeId: {
    id: `${scope}.badgeId`,
    defaultMessage: 'Badge ID',
  },
  OwnerDetailTextLoyalty: {
    id: `${scope}.OwnerDetailTextLoyalty`,
    defaultMessage:
      '{program} / Activity: {activity}',
  },
  OwnerDetailTextMilestone: {
    id: `${scope}.OwnerDetailTextMilestone`,
    defaultMessage:
      '{name} / Trigger: {trigger} {id, select, NULL {} other {(ID: {id})}}',
  },
  OwnerDetailTextJourney: {
    id: `${scope}.OwnerDetailTextJourney`,
    defaultMessage:'{journeyName}',
  },
  OwnerDetailTextCampaign: {
    id: `${scope}.OwnerDetailTextCampaign`,
    defaultMessage: '{campaignName}',
  },
  badgeGroup: {
    id: `${scope}.badgeGroup`,
    defaultMessage: 'Badge group',
  },
  badgeRanking: {
    id: `${scope}.badgeRanking`,
    defaultMessage: 'Badge rank',
  },
  badgeIssueType: {
    id: `${scope}.badgeIssueType`,
    defaultMessage: 'Badge issue type',
  },
  badgeIssueTypePlaceholder: {
    id: `${scope}.badgeIssueTypePlaceholder`,
    defaultMessage: 'Define how the badges will be issued to the customers',
  },
  enrolAndIssue: {
    id: `${scope}.enrolAndIssue`,
    defaultMessage: 'Enrol & Issue',
  },
  issueWithoutEnrol: {
    id: `${scope}.issueWithoutEnrol`,
    defaultMessage: 'Directly Issued without Enrolment',
  },
  enrolAndIssueTooltip: {
    id: `${scope}.enrolAndIssueTooltip`,
    defaultMessage:
      'Only selected customers are enrolled for these badges and the badges will be issued once they fulfil the issuance condition ',
  },
  issueWithoutEnrolTooltip: {
    id: `${scope}.issueWithoutEnrolTooltip`,
    defaultMessage:
      'Badges are not limited to a specific audience. They can be issued directly to anyone who fulfils the issuance criteria ',
  },
  enrolmentExpiry: {
    id: `${scope}.enrolmentExpiry`,
    defaultMessage: 'Enrolment expiry',
  },
  enrolmentExpiryTooltip: {
    id: `${scope}.enrolmentExpiryTooltip`,
    defaultMessage:
      'This is the duration from the badge start date till user can be enrolled to the badge',
  },
  moreText: {
    id: `${scope}.moreText`,
    defaultMessage: '+{value} more',
  },
  coupon: {
    id: `${scope}.coupon`,
    defaultMessage: 'Coupon',
  },
  expiryDate: {
    id: `${scope}.expiryDate`,
    defaultMessage: 'Expiry date',
  },
  onContextEndDate: {
    id: `${scope}.onContextEndDate`,
    defaultMessage: 'On context end date',
  },
  claim: {
    id: `${scope}.claim`,
    defaultMessage: 'Claim',
  },
  type: {
    id: `${scope}.type`,
    defaultMessage: 'Type',
  },
  mandatory: {
    id: `${scope}.mandatory`,
    defaultMessage: 'Mandatory',
  },
  defaultValue: {
    id: `${scope}.defaultValue`,
    defaultMessage: 'Default value',
  },
  string: {
    id: `${scope}.string`,
    defaultMessage: 'String',
  },
  number: {
    id: `${scope}.number`,
    defaultMessage: 'Number',
  },
  boolean: {
    id: `${scope}.boolean`,
    defaultMessage: 'Boolean',
  },
  integer: {
    id: `${scope}.integer`,
    defaultMessage: 'Integer',
  },
  discard: {
    id: `${scope}.discard`,
    defaultMessage: 'Discard',
  },
  enterDescPlaceholder: {
    id: `${scope}.enterDescPlaceholder`,
    defaultMessage: 'Enter description',
  },
  enterNamePlaceholder: {
    id: `${scope}.enterNamePlaceholder`,
    defaultMessage: 'Enter name',
  },
  enterNumberPlaceholder: {
    id: `${scope}.enterNumberPlaceholder`,
    defaultMessage: 'Enter number',
  },
  enterDatePlaceholder: {
    id: `${scope}.enterDatePlaceholder`,
    defaultMessage: 'Select date',
  },
  enterStringPlaceholder: {
    id: `${scope}.enterStringPlaceholder`,
    defaultMessage: 'Enter string value',
  },
  moduleNotImplementedError: {
    id: `${scope}.moduleNotImplementedError`,
    defaultMessage: 'Coming Soon!',
  },
  notFoundError: {
    id: `${scope}.notFoundError`,
    defaultMessage: 'Linked {key} {value} is invalid',
  },
  invalidReferenceIdError: {
    id: `${scope}.invalidReferenceIdError`,
    defaultMessage: 'Linked instance ID {value} is invalid',
  },
  accessForbiddenError: {
    id: `${scope}.accessForbiddenError`,
    defaultMessage: ' You don’t have access to the module.',
  },
  unableToFetchDetails: {
    id: `${scope}.unableToFetchDetails`,
    defaultMessage: 'Unable to fetch details',
  },
  refresh: {
    id: `${scope}.refresh`,
    defaultMessage: 'Refresh',
  },
  onFixedDate: {
    id: `${scope}.onFixedDate`,
    defaultMessage: 'On fixed date',
  },
  afterSpecificEnrolPeriod: {
    id: `${scope}.afterSpecificEnrolPeriod`,
    defaultMessage: 'After specific period from customer’s enrolment',
  },
  afterSpecificIssuePeriod: {
    id: `${scope}.afterSpecificIssuePeriod`,
    defaultMessage: 'After specific period from badge issual',
  },
  alongWithBadgeEndDate: {
    id: `${scope}.alongWithBadgeEndDate`,
    defaultMessage: 'Along with badge end date',
  },
  neverExpires: {
    id: `${scope}.neverExpires`,
    defaultMessage: 'Never expires',
  },
  badgeNumberInputPlaceholder: {
    id: `${scope}.badgeNumberInputPlaceholder`,
    defaultMessage: 'Eg: 4',
  },
  individualCustomerLimit: {
    id: `${scope}.individualCustomerLimit`,
    defaultMessage: 'Individual customer limit',
  },
  acrossCustomerLimit: {
    id: `${scope}.acrossCustomerLimit`,
    defaultMessage: 'Across customer limit',
  },
  fixedWindow: {
    id: `${scope}.fixedWindow`,
    defaultMessage: 'Fixed window',
  },
  movingWindow: {
    id: `${scope}.movingWindow`,
    defaultMessage: 'Moving window',
  },
  selectDuration: {
    id: `${scope}.selectDuration`,
    defaultMessage: 'select duration',
  },
  sunday: {
    id: `${scope}.sunday`,
    defaultMessage: 'Sunday',
  },
  monday: {
    id: `${scope}.monday`,
    defaultMessage: 'Monday',
  },
  tuesday: {
    id: `${scope}.tuesday`,
    defaultMessage: 'Tuesday',
  },
  wednesday: {
    id: `${scope}.wednesday`,
    defaultMessage: 'Wednesday',
  },
  thursday: {
    id: `${scope}.thursday`,
    defaultMessage: 'Thursday',
  },
  friday: {
    id: `${scope}.friday`,
    defaultMessage: 'Friday',
  },
  saturday: {
    id: `${scope}.saturday`,
    defaultMessage: 'Saturday',
  },
  specificDuration: {
    id: `${scope}.specificDuration`,
    defaultMessage: 'specific duration',
  },
  overallBadgeDuration: {
    id: `${scope}.overallBadgeDuration`,
    defaultMessage: 'overall badge duration',
  },
  specificNoOfDays: {
    id: `${scope}.specificNoOfDays`,
    defaultMessage: 'specific no. of days',
  },
  week: {
    id: `${scope}.week`,
    defaultMessage: 'week',
  },
  calendarMonth: {
    id: `${scope}.calendarMonth`,
    defaultMessage: 'calendar month',
  },
  noLimit: {
    id: `${scope}.noLimit`,
    defaultMessage: 'No limit',
  },
  movingWindowLimit: {
    id: `${scope}.movingWindowLimit`,
    defaultMessage: 'Moving window: {limitCount} limit',
  },
  offers: {
    id: `${scope}.offers`,
    defaultMessage: 'Offers',
  },
  giftVouchers: {
    id: `${scope}.giftVouchers`,
    defaultMessage: 'Gift vouchers',
  },
  cartPromotions: {
    id: `${scope}.cartPromotions`,
    defaultMessage: 'Cart promotions',
  },
  issueCoupon: {
    id: `${scope}.issueCoupon`,
    defaultMessage: 'Issue coupon',
  },
  allocatePoints: {
    id: `${scope}.allocatePoints`,
    defaultMessage: 'Allocate points',
  },
  issueGiftVoucher: {
    id: `${scope}.issueGiftVoucher`,
    defaultMessage: 'Issue gift voucher',
  },
  issueCartPromotion: {
    id: `${scope}.issueCartPromotion`,
    defaultMessage: 'Issue cart promotion',
  },
  badgeBasicDetailsConfigPaneTabDesc: {
    id: `${scope}.badgeBasicDetailsConfigPaneTabDesc`,
    defaultMessage:
      '{ownerCount} owner(s), {imageCount} image(s), {customFieldCount} custom field(s) defined',
  },
  indexValue: {
    id: `${scope}.indexValue`,
    defaultMessage: '{value}',
  },
  editBadgeConfirmationModal_1: {
    id: `${scope}.editBadgeConfirmationModal_1`,
    defaultMessage: 'The changes will apply to the new badge issuals only',
  },
  editBadgeConfirmationModal_2: {
    id: `${scope}.editBadgeConfirmationModal_2`,
    defaultMessage: 'Are you sure you want to continue with the new changes?',
  },
  yesContinue: {
    id: `${scope}.yesContinue`,
    defaultMessage: 'Yes, continue',
  },
  updateChanges: {
    id: `${scope}.updateChanges`,
    defaultMessage: 'Update changes',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: 'Continue',
  },
  apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Apply',
  },
  invalidPastDate: {
    id: `${scope}.invalidPastDate`,
    defaultMessage: 'Date is invalid as it cannot be in the past',
  },
  customFieldName: {
    id: `${scope}.customFieldName`,
    defaultMessage: '{name}',
  },
  addCustomField: {
    id: `${scope}.addCustomField`,
    defaultMessage: 'Add custom field',
  },
  resetCustomField: {
    id: `${scope}.resetCustomField`,
    defaultMessage: 'Reset to default value',
  },
  resetBoolean: {
    id: `${scope}.resetBoolean`,
    defaultMessage: 'Reset',
  },
  deleteCustomField: {
    id: `${scope}.deleteCustomField`,
    defaultMessage: 'Remove custom field',
  },
  true: {
    id: `${scope}.true`,
    defaultMessage: 'True',
  },
  false: {
    id: `${scope}.false`,
    defaultMessage: 'False',
  },
  addValue: {
    id: `${scope}.addValue`,
    defaultMessage: 'Add {value}',
  },
  claimDisabledTooltip: {
    id: `${scope}.claimDisabledTooltip`,
    defaultMessage: 'Select at least 1 badge to proceed',
  },
  addLimit: {
    id: `${scope}.addLimit`,
    defaultMessage: 'Add limit',
  },
  addCustomFieldDisabledTooltip: {
    id: `${scope}.addCustomFieldDisabledTooltip`,
    defaultMessage: 'All custom fields have been added',
  },
  remove: {
    id: `${scope}.remove`,
    defaultMessage: 'Remove',
  },
  viewCustomFieldDisabledTooltip: {
    id: `${scope}.viewCustomFieldDisabledTooltip`,
    defaultMessage: 'No custom field added',
  },
  wordLimitExceed: {
    id: `${scope}.wordLimitExceed`,
    defaultMessage: 'It should not exceed the maximum character limit',
  },
  exitBadgeModalTitle: {
    id: `${scope}.exitBadgeModalTitle`,
    defaultMessage: 'Exit Badges?',
  },
  exitBadgeModalBody: {
    id: `${scope}.exitBadgeModalBody`,
    defaultMessage:
      'This action will result in the loss of all unsaved changes which is a non-reversible action.',
  },
  exitBadgeModalConfirm: {
    id: `${scope}.exitBadgeModalConfirm`,
    defaultMessage: 'Are you sure you want to cancel & exit?',
  },
  continueEditing: {
    id: `${scope}.continueEditing`,
    defaultMessage: 'Continue editing',
  },
  yesExit: {
    id: `${scope}.yesExit`,
    defaultMessage: 'Yes, exit',
  },
  customFieldType: {
    id: `${scope}.customFieldType`,
    defaultMessage: 'Data type',
  },
  lastUpdatedOn: {
    id: `${scope}.lastUpdatedOn`,
    defaultMessage: 'Last Updated on',
  },
  updatedBy: {
    id: `${scope}.updatedBy`,
    defaultMessage: 'Updated by',
  },
  removeLimitConfirmationModalTitle: {
    id: `${scope}.removeLimitConfirmationModalTitle`,
    defaultMessage: 'Remove "{isIssueLimitTypeIndividual, select, true{Individual customer} false{Across customer}} limit?”',
  },
  removeLimitConfirmationModalDesc_1: {
    id: `${scope}.removeLimitConfirmationModalDesc_1`,
    defaultMessage: 'Removing the "{isIssueLimitTypeIndividual, select, true{Individual customer} false{Across customer}} limit” would result in the loss of existing configuration. You can also add the limit later.',
  },
  removeLimitConfirmationModalDesc_2: {
    id: `${scope}.removeLimitConfirmationModalDesc_2`,
    defaultMessage: 'Are you sure you want to continue?',
  },
  activeLimitCycleEndDateInfoNote: {
    id: `${scope}.activeLimitCycleEndDateInfoNote`,
    defaultMessage: 'The updated fixed window will start after the current fixed window period ends on {endDate}',
  },
  updatedFixedWindowInfoNote: {
    id: `${scope}.updatedFixedWindowInfoNote`,
    defaultMessage: 'The updated fixed window will start from today',
  },
  advancedFilters: {
    id: `${scope}.advancedFilters`,
    defaultMessage: 'Advanced filters',
  },
  linkedBenefits: {
    id: `${scope}.linkedBenefits`,
    defaultMessage: 'Linked benefits',
  },
});
